// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1DZAT","title":"InfoRow_title__3_LVd"};